import _ from "lodash";
import {
  VERTRAGSARTEN_TARIF,
} from "App/constants";
import {
  formatDate,
} from "CommonCore/l10n";
import moment from "moment";

export const schema = {
  displayName: "Tarifdaten",
  table: [
    {
      field: "atd_aid",
      readonly: true,
      hideFromDetail: true,
      hideFromEditor: () => true,
    },
    {
      field: "atd_artid",
      display: "Vertragsart",
      type: "select",
      required: true,
      inject: ["k_vertragsartLookup"],
      choices: lookup => lookup && _.map(_.filter(lookup, va => VERTRAGSARTEN_TARIF.indexOf(va.art_id) >= 0), va => ({ value: va.art_id, label: va.art_kbez })),
      selector: lookup => id => lookup && id && _.get(lookup, [id, "art_kbez"], ""),
    },
    {
      field: "atd_kzgid",
      display: "Zugangsgrund",
      type: "select",
      required: true,
      inject: ["k_zugangsgrundLookup"],
      choices: lookup => lookup && _.map(lookup, zg => ({ value: zg.kzg_id, label: zg.kzg_kbez })),
      selector: lookup => id => lookup && id && _.get(lookup, [id, "kzg_kbez"], ""),
    },
    {
      field: "atd_ist_wiss",
      display: "wiss. Personal",
      type: "checkbox",
      readonly: true,
    },
    {
      field: "atd_daid",
      display: "Dienstart",
      type: "select",
      required: true,
      inject: ["k_dienstartLookup"],
      choices: lookup => entity => lookup && entity && _.map(
        _.filter(lookup, da => entity.atd_ist_wiss ? da.da_art === "1" : da.da_art === "2"),
        da => ({ value: da.da_id, label: da.da_bez }),
      ),
      selector: lookup => id => lookup && id && _.get(lookup, [id, "da_bez"], ""),
    },
    {
      field: "atd_ktaid",
      display: "Ausgeübte Tätigkeit",
      type: "select",
      required: true,
      inject: ["k_astat_occupationLookup"],
      choices: lookup => lookup && _.map(lookup, kta => ({ value: kta.kta_id, label: `${ kta.kta_bez } - ${ kta.kta_svakey }` })),
      selector: lookup => id => (lookup && id && lookup[id] && `${ lookup[id].kta_bez } - ${ lookup[id].kta_svakey }`) || "",
    },
    {
      field: "atd_bvgid",
      display: "Eingruppierung",
      type: "select",
      required: true,
      inject: ["k_bvlgruppeLookup"],
      choices: lookup => lookup && _.map(lookup, bvg => ({ value: bvg.bvg_id, label: bvg.bvg_kbez })),
      selector: lookup => id => lookup && id && _.get(lookup, [id, "bvg_kbez"], ""),
    },
    {
      field: "atd_bvsid",
      display: "Einstufung",
      type: "select",
      required: true,
      inject: ["k_bvlstufeLookup"],
      choices: lookup => lookup && _.map(_.filter(lookup, item => item.bvs_svakey[0] !== "B"), bvs => ({ value: bvs.bvs_id, label: bvs.bvs_svakey })),
      selector: lookup => id => lookup && id && _.get(lookup, [id, "bvs_svakey"], ""),
    },
    {
      field: "atd_nextbvs_date",
      display: "Datum des nächsten Stufenaufstiegs",
      type: "date",
      required: true,
    },
    {
      field: "atd_tvl_fallgruppe",
      display: "TVL Fallgruppe",
      maxlength: 6,
      required: true,
    },
    {
      field: "atd_tvl_teil",
      display: "TVL Teil",
      maxlength: 3,
      required: true,
    },
    {
      field: "atd_tvl_abschnitt",
      display: "TVL Abschnitt",
      maxlength: 5,
      required: true,
    },
    {
      field: "atd_klbid",
      display: "Laufbahn",
      type: "select",
      required: true,
      inject: ["k_laufbahnLookup"],
      choices: lookup => lookup && _.map(lookup, klb => ({ value: klb.klb_id, label: klb.klb_kbez })),
      selector: lookup => id => lookup && id && _.get(lookup, [id, "klb_kbez"], ""),
    },
    {
      field: "atd_erlaeuterungen",
      display: "Weitere Erläuterungen",
      type: "textarea",
      rows: 5,
      maxlength: 1000,
    },
    {
      field: "atd_anschreibentext",
      display: "Aufgabenänderung/Absenkung",
      type: "textarea",
      rows: 5,
      maxlength: 1000,
    },
  ],
};

export const validateTarif = (tarifdaten, antrag) => {
  // nächste Stufenerhöhung muss NACH Vertragsbeginn sein
  if (tarifdaten.atd_nextbvs_date && moment(tarifdaten.atd_nextbvs_date).isBefore(moment(antrag.plan_beginn))) {
    const e = new Error();
    e.response = {
      nachricht: "Es ist ein Fehler aufgetreten",
      details: [{ attribut: "atd_nextbvs_date", nachricht: `Bitte geben Sie ein Datum nach dem ${ formatDate(antrag.plan_beginn) } (geplanter Vertragsbeginn) an.` }],
    };
    return e;
  }

  // required Felder forcieren
  let err = null;
  schema.table.some(entry => {
    if (entry.required && (tarifdaten[entry.field] == null || tarifdaten[entry.field] == undefined)) {
      err = new Error();
      err.response = {
        nachricht: "Es ist ein Fehler aufgetreten",
        details: [{ attribut: entry.field, nachricht: `Bitte geben Sie einen Wert an für: ${ entry.display }` }],
      };
      return true;
    }
  });
  return err;
};
